import { useState, useEffect, useRef } from "react";
import "../../../../../css/AML/Tooltip/AMLTooltip.css";

const InfoTooltip = ({ children, text, position = "left" }) => {
  const [open, setOpen] = useState(false);
  const [locked, setLocked] = useState(false);
  const ref = useRef(null);

  // Clicking outside closes tooltip + unlocks
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setLocked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div
      className="TooltipContainer"
      ref={ref}
      onMouseEnter={() => setOpen(true)} // hover open
      onMouseLeave={() => {
        if (!locked) setOpen(false); // close only if not locked
      }}
      onClick={(e) => {
        e.stopPropagation();
        setLocked(true); // lock open
        setOpen(true);
      }}
    >
      {children}

      {open && (
        <div className={`TooltipBubble Info Tooltip-${position}`}>
          <div className="AML-Text-Body">{text}</div>
          <span className={`TooltipArrow Info TooltipArrow-${position}`} />
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
